import React from 'react'
import LazyLoad from 'react-lazyload'

function LazyLoadedMedia({ children }) {
  return (
    <LazyLoad offset={150} once>
      {children}
    </LazyLoad>
  );
}

export default LazyLoadedMedia
